<manage-wrapper
  *ngIf="!!sponsor"
  [canEditMain]="!data.readOnly"
  [entityTitle]="sponsor.name || ''"
  [tabGroups]="tabGroups"
  [selectedTab]="selectedTab"
  [topToggleText]="'SHOW IN PUBLISH'"
  [topToggled]="!sponsor.hideInPublish"
  [readOnly]="data.readOnly"
  [labels]="sponsor.labels || []"
  [labelMap]="labelMap"
  [labelList]="labels"
  [clipLabel]="clipLabel"
  [deleteTitle]="'Delete this Sponsor'"
  [labelUpdateFunction]="labelUpdateFunction.bind(this)"
  [type]="'sponsor'"
  [titlePlaceholder]="'Sponsor name'"
  [backgroundColor]="'#41474F'"
  [dialogTitle]="'Manage Sponsor'"
  [canDuplicate]="false"
  [showStars]="true"
  [stars]="sponsor.stars || 0"
  (saveStars)="saveStars($event)"
  (onToggle)="changeHideInPublish()"
  (onDone)="exit()"
  (onChangeTab)="changeTab($event)"
  (saveTitle)="updateTitle($event)"
  (onDelete)="delete()"
  (onClip)="clip()"
>
  <div class="afterTitle">
    <menu-hover-button 
      id="sponsor-type"
      [readOnly]="data.readOnly"
      *ngIf="{ sponsorType: sponsor.sponsorTypeId && sponsorTypes[sponsor.sponsorTypeId] ? sponsorTypes[sponsor.sponsorTypeId].name : null } as vars"
      [iconSelector]="'SPONSOR24'" 
      [hoverText]="'Sponsor type'" 
      [text]="vars.sponsorType || 'Sponsor type'"
      [lightText]="!vars.sponsorType"
      [tooltipLeft]="true"
      (click)="data.readOnly ? null : manageSponsorType()">
    </menu-hover-button>

  </div>

  <ng-container *ngIf="!selectedTab || selectedTab?.id === tabs.details">
    <div class="toggle-holder">
      <div style="flex:1;"></div>
      <toggle-tab class="inner-toggle" [bottomTab]="false" [hideToggle]="data.readOnly" [text]="'PROFILE ' + (sponsor.confirmed ? '' : 'NOT ') + 'CONFIRMED'" [toggled]="!!sponsor.confirmed" (toggle)="toggleConfirmed()"></toggle-tab>
    </div>

    <tip-text class="ex-profile" *ngIf="sponsorShareable?.status == 'Active'" [type]="'warn'" [head]="'Attention:'" [body]="'This sponsor has an active webform to edit profile information.'"></tip-text>
    <tip-text class="ex-profile" *ngIf="!sponsorShareable || sponsorShareable.status != 'Active'" [type]="'tip'" [head]="'Tip:'" [body]="'Sponsors can submit their profile information using a shareable link by turning on the <strong>Profile webform for editing</strong> below.'"></tip-text>
    <div>Share webform to receive sponsor profile information.</div>
    <binary-share-toggle
      [type]="'profile'"
      style="display: block; margin-bottom: 20px;"
      [shareType]="shareTypes.sponsor"
      [hideBottom]="!sponsorShareable"
      [shareableFormat]="'oneLine'"
      [shareCode]="sponsorShareable?.code || ''"
      [hint]="'Note: Once a submission is made the status will change from “Active” to “Submitted” and the link will be closed. To re-enable the link, change the status back to “Active”.'"
      [title]="'Profile webform'"
      [shareTitle]="'Your shareable webform:'"
      [generatingCode]="generatingEditCode"
      [status]="sponsorShareable?.status || undefined"
      (toggle)="toggleSponsorProfile()"
      (changeStatus)="changeSponsorProfileStatus($event)"
    ></binary-share-toggle>
  
    <div class="uploaders-holder">
      <image-uploader 
        [id]="sponsor.id || ''"
        (newUrls)="changeImage($event)"
        [immediate]="true" 
        [isLogo]="true"
        [displayType]="imageUploaderDisplayTypes.widePodLogo"
        [thumbUrl]="sponsor.logoUrl" 
        [photoUrl]="sponsor.fullLogoUrl"
        [eventId]="event?.eventId || ''"
        [type]="'sponsor'" 
        [subtype]="'logo'" 
        [placeholder]="'Add logo'" 
        [uploadText]="'UPLOAD LOGO'"
        [saveName]="sponsor.name"
      ></image-uploader>
    </div>

    <manage-social [links]="sponsor?.social || []" (saveLinks)="saveSocialLinks($event)"></manage-social>

    <h3 class="description-title">Description</h3>
    <!--<joi-input class="description" [disabled]="data.readOnly" [italicPlaceholder]="true" [(model)]="sponsor.description" [type]="'textarea'" [returnable]="true" [placeholder]="'Click to add sponsor description...'" (joiChange)="saveSponsor()"></joi-input>
-->
    <input-editor 
      [disabled]="data.readOnly"
      [object]="sponsor" 
      [prop]="'description'" 
      [placeholder]="'Click to add sponsor description...'"
      (changed)="saveSponsor()"
    ></input-editor>

    <manage-call-to-action
      [entity]="sponsor"
      [ctaProp]="'callToAction'"
      [urlProp]="'callToActionUrl'"
      [readOnly]="data.readOnly"
      (ctaDetailsChanged)="saveSponsor()"
    ></manage-call-to-action>

    <hr class="big-rule"/>

    <manage-contact-details
      [entity]="sponsor"
      [entityName]="'Sponsor'"
      [nameProp]="'contactName'"
      [numberProp]="'contactNumber'"
      [emailProp]="'contactEmail'"
      [readOnly]="data.readOnly"
      (contactDetailsChanged)="saveSponsor()"
    ></manage-contact-details>

    <custom-questions-app
      [entity]="sponsor"
      [entityType]="'sponsor'"
      (updateQuestion)="updateCustomQuestion($event)"
    ></custom-questions-app>


  </ng-container>

  <ng-container *ngIf="selectedTab?.id === tabs.assets">
    <assets 
      [title]="'Associated Assets'"
      [associatedId]="sponsor.id || ''"
      [assetIds]="associatedAssetIds"
      [entityHolderName]="'sponsor'"
      [readOnly]="data.readOnly"
    ></assets>

    <ng-container *ngIf="!data.readOnly">
      <edit-associated-assets-manager *ngIf="!!sponsor" style="margin-top: 30px;"
        [type]="'sponsor'"
        [entity]="sponsor"
        [view]="'shareable'"
      ></edit-associated-assets-manager>
    </ng-container>

  </ng-container>


  <ng-container *ngIf="selectedTab?.id === tabs.contact">
    <manage-contact
      [workforceContactEmail]="sponsor?.WFContact || ''" 
      [readOnly]="data.readOnly"
      (changeContact)="changeWorkforceContact($event)"
    ></manage-contact>
  </ng-container>

  <ng-container *ngIf="selectedTab?.id === tabs.sessions">   
    <add-manage-wrapper [hideHRule]="true" class="session-list" [openLabel]="sessionProgramList.length && event && !event.is_readonly ? '+ ADD TO A SESSION' : ''" (open)="sessionProgramList.length ? addToASession($event) : null">
      <div class="session-message">
        
        <div *ngIf="!sponsorTableData?.nestedIds?.length" class="empty-text">This sponsor is not assigned to any sessions.</div>
        <ng-container *ngIf="sponsorTableData?.nestedIds?.length">
          <traffic-light *ngFor="let light of sponsorTableData.sessionSummary.lights" [color]="light.color" [text]="light.text"></traffic-light>
        </ng-container>
      </div>

      <status-wrapper *ngFor="let session of sessionList"
        class="sessions"
        [status]="session.status"
        [statusOptions]="statusOptions"
        [ngClass]="{ clickable: !data.readOnly }"
        [deleteTitle]="'Remove ' + sponsor.name + ' from this session'"
        [wideFormat]="true"
        [readOnly]="data.readOnly"
        [threeDotOptions]="threeDotSessionOptions"
        (changeStatus)="changeStatus(session, $event)"
        (threeDotSelection)="sessionDotMenuSelection($event, session)"
        (click)="data.readOnly? null : manageSession(session)"
      >
        
        <big-and-grey class="wideContent" [theTitle]="session.title" greyText="{{ session.start }} - {{ session.end }}, {{ (session.day ? session.day : session.date | date: 'd MMMM y') }}" ></big-and-grey>
      </status-wrapper>
    </add-manage-wrapper>
  </ng-container>

  <ng-container *ngIf="selectedTab?.id === tabs.quickNotes">
    <chat-box [isNotes]="true" [comments]="sponsor.quickNotes || []" [readOnly]="data.readOnly" (quickNotesChanged)="saveQuickNotes($event)" ></chat-box>
  </ng-container>

  <entity-tasks *ngIf="selectedTab?.id === tabs.tasks" [entity]="sponsor" [changeDetectorRef]="changeDetectorRef"></entity-tasks>

</manage-wrapper>